import React from 'react';
import { connect } from 'react-redux';
import BillboardMovieDetailsBlock from "./BillboardMovieDetailsBlock";
import BillboardMoviePoster from "./BillboardMoviePoster";
import styled from 'styled-components';
import { CinemaType, MovieType } from '../../types/entities';
import { groupVersionsByLanguage } from '../../utils/showtimes';
import ShowtimesLanguageBlock from '../common/Showtimes/ShowtimesLanguageBlock';
import { getBootstrapFilters } from '../../reducers';

const Movie = styled.div`
  border-bottom: 1px solid var(--text-primary);
  padding-bottom: var(--pad-y);
  padding-top: 2rem;
  margin-bottom: 2rem;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }
`

interface Props {
  attributes?: { [key: string]: { display_name: string } };
  cinema: CinemaType;
  movie: MovieType & { versions?: Array<any> };
}

interface State {
  expanded: boolean;
  trailer: boolean;
}

class BillboardMovieBlock extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.onExpandedToggle = this.onExpandedToggle.bind(this);
    this.onTrailerToggle = this.onTrailerToggle.bind(this);
    this.onTrailerClose = this.onTrailerClose.bind(this);

    this.state = {
      expanded: false,
      trailer: false,
    };
  }

  onExpandedToggle() {
    this.setState(prevState => ({expanded: !prevState.expanded}));
  }

  onTrailerToggle() {
    this.setState(prevState => ({trailer: !prevState.trailer}));
  }

  onTrailerClose() {
    this.setState(prevState => ({trailer: false}));
  }

  render() {
    const {movie} = this.props;
    const {versions} = movie;

    if (!versions || !versions.length) {
      return '';
    }

    const sessionsByLanguage = groupVersionsByLanguage(versions);

    return (
        <Movie data-movie-id={movie.id} className='container'>
          <div className="row">
            <div className="col col-3 col-lg-2 d-none d-md-block">
              <BillboardMoviePoster movie={movie} onTrailerToggle={this.onTrailerToggle}/>
            </div>
            <div className="col col-md-9 col-lg-10">
              <BillboardMovieDetailsBlock movie={movie} trailerOpen={this.state.trailer} onTrailerClose={this.onTrailerClose} onTrailerToggle={this.onTrailerToggle}/>
              {Object.keys(sessionsByLanguage).map(lang => this.props.attributes && this.props.attributes[lang] && <ShowtimesLanguageBlock
                key={lang}
                language={this.props.attributes[lang].display_name}
                showtimes={sessionsByLanguage[lang]}
                cinema={this.props.cinema}
                movie={movie}
              />)}
            </div>
          </div>
        </Movie>
    );
  }
}

const mapStateToProps = (state: any) => ({
    attributes: getBootstrapFilters(state),
});

export default connect(
    mapStateToProps
)(BillboardMovieBlock);